<span class="author-name nordic-blue-900-text font-body-1 medium-type">{{ author }}</span>
